import DialogBox from './dialogbox';

export default DialogBox;
